import { Injectable } from '@angular/core';
import { SearchOption } from '../interfaces/searchoption.model';
import { IClaim } from '../interfaces/claims.model';

@Injectable({
  providedIn: 'root'
})
export class SearchOptionService {

  public mapClaimsToSearchOptions(claims: Array<IClaim>): Array<SearchOption> {
    return claims
      .map(claim => ({
        id: claim.claimId,
        name: claim.wording,
        code: claim.claimId.toString()
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  public filterClaims(claims: Array<IClaim>, searchTerm: string): Array<IClaim> {
    if (!searchTerm || searchTerm.length < 1) {
      return claims;
    }

    const searchLower = searchTerm.toLowerCase();
    return claims.filter(claim => 
      claim.wording?.toLowerCase().includes(searchLower) ||
      claim.client?.toLowerCase().includes(searchLower) ||
      claim.claimId.toString().includes(searchTerm) ||
      claim.officeCode?.toLowerCase().includes(searchLower)
    );
  }

  public createNoResultsOption(searchTerm?: string): SearchOption {
    return {
      id: 'no-results',
      name: searchTerm ? `No results matching "${searchTerm}"` : 'No results found',
      code: 'no-results',
      disabled: true
    };
  }

  public createErrorOption(message: string): SearchOption {
    return {
      id: 'error',
      name: message,
      code: 'error',
      disabled: true
    };
  }
}
